import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React from "react";
import { useStoreState } from "pullstate";
import Store from "../utils/Store";
import Button from "./common/Button";
import Modal from "./common/Modal";
import classNames from "classnames";
var labelsDefault = {
  title: "Confirmation modal",
  label: "Click yes to confirm",
  yes: "Confirm",
  no: "Cancel"
};
var ConfirmationModal = function ConfirmationModal(props) {
  var _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {
      return null;
    } : _props$onClose,
    _props$onClickConfirm = props.onClickConfirm,
    onClickConfirm = _props$onClickConfirm === void 0 ? function () {
      return null;
    } : _props$onClickConfirm,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? labelsDefault : _props$labels,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className;
  var _labels$title = labels.title,
    title = _labels$title === void 0 ? "" : _labels$title,
    label = labels.label,
    yes = labels.yes,
    no = labels.no;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.isConfirmationModalOpen
      };
    }),
    isVisible = _useStoreState.isVisible;
  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    onClose: onClose,
    title: title,
    className: classNames("w-full sm:w-4/12 lg:w-3/12", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6 text-left"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-col sm:justify-end sm:flex-row p-4 border-t border-t-gray-700"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "grow-1 ml-4 w-full sm:w-auto py-4 px-6",
    onClick: onClose
  }, no), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    isLoading: isLoading,
    className: "mt-3 sm:mt-0 grow-1 ml-4 w-full sm:w-auto py-4 px-6",
    onClick: onClickConfirm
  }, yes)));
};
export default ConfirmationModal;